import React from 'react';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { InsightsSection } from '../components/InsightsSection';
import { SearchIcon } from 'lucide-react';
export function MissingPersonsInvestigations() {
  return <div className="flex flex-col min-h-screen w-full bg-white" data-id="element-442">
      <Header data-id="element-443" />

      {/* Banner Section */}
      <section className="relative w-full h-[400px] bg-gradient-to-br from-kgi-blue-900 to-kgi-blue-800 overflow-hidden mt-20" data-id="element-444">
        <div className="absolute inset-0 bg-black opacity-20" data-id="element-445"></div>
        <div className="relative container mx-auto px-4 h-full flex items-center justify-center" data-id="element-446">
          <div className="text-center" data-id="element-447">
            <SearchIcon className="h-20 w-20 text-white mx-auto mb-6 drop-shadow-lg" data-id="element-448" />
            <h1 className="font-serif text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-4 drop-shadow-lg" data-id="element-449">
              Missing Persons Investigations
            </h1>
            <p className="text-xl text-blue-100 max-w-2xl mx-auto drop-shadow" data-id="element-450">
              Expert location services to reunite families and find answers
            </p>
          </div>
        </div>
      </section>

      {/* Content Section */}
      <section className="py-16 bg-white" data-id="element-451">
        <div className="container mx-auto px-4" data-id="element-452">
          <div className="max-w-4xl mx-auto" data-id="element-453">
            <div className="prose prose-lg max-w-none mb-12" data-id="element-454">
              <p className="text-xl text-gray-700 leading-relaxed mb-6" data-id="element-455">
                When someone goes missing, time is critical. Koda Group Inc.
                provides professional missing persons investigation services to
                help families find their loved ones and bring them home safely.
                Our investigators use advanced skip tracing techniques, database
                searches, and field investigation to locate missing persons
                quickly and efficiently. We work with families, law enforcement,
                and legal professionals to coordinate search efforts and
                maximize the chances of a successful outcome.
              </p>

              <p className="text-lg text-gray-600 leading-relaxed mb-6" data-id="element-456">
                Whether you're searching for a runaway teenager, an estranged
                family member, a birth parent, or someone who has disappeared
                under suspicious circumstances, our team has the resources and
                expertise to help. We maintain nationwide databases and have
                established relationships with investigators across the country,
                allowing us to conduct searches anywhere in the United States.
                Our compassionate approach recognizes the emotional toll of
                missing persons cases while maintaining the professionalism
                needed to conduct effective investigations.
              </p>

              <p className="text-lg text-gray-600 leading-relaxed mb-8" data-id="element-457">
                Our missing persons investigation services include skip tracing
                and location services, runaway teen location, estranged family
                member searches, birth parent and adoption searches, witness and
                debtor location, database searches and public records research,
                field investigation and interviews, and coordination with law
                enforcement agencies. We provide regular updates and maintain
                open communication throughout the search process.
              </p>
            </div>

            <div className="text-center bg-gray-50 rounded-lg p-8" data-id="element-458">
              <h3 className="font-serif text-2xl font-bold text-kgi-blue-900 mb-4" data-id="element-459">
                Start Your Search Today
              </h3>
              <p className="text-gray-700 mb-6 max-w-2xl mx-auto" data-id="element-460">
                Contact us immediately to begin your missing persons
                investigation. Time is critical.
              </p>
              <a href="/contact-koda-private-investigators.html" className="inline-flex items-center bg-kgi-red hover:bg-kgi-red-600 text-white font-bold py-4 px-10 rounded-full transition duration-300 shadow-xl text-lg" data-id="element-461">
                Schedule a Consultation
              </a>
            </div>
          </div>
        </div>
      </section>

      <InsightsSection data-id="element-462" />
      <Footer data-id="element-463" />
    </div>;
}